import type { CSSProperties } from 'react';
import { splitDomMetadata, type DomMetadata } from './dom-metadata';

const paths = {
  // An App: three App tiles and the Poneva spark as the fourth, the one you make by asking.
  app: 'M5.2 3h2.6a2.2 2.2 0 0 1 2.2 2.2v2.6a2.2 2.2 0 0 1-2.2 2.2h-2.6a2.2 2.2 0 0 1-2.2-2.2v-2.6a2.2 2.2 0 0 1 2.2-2.2Zm0 11h2.6a2.2 2.2 0 0 1 2.2 2.2v2.6a2.2 2.2 0 0 1-2.2 2.2h-2.6a2.2 2.2 0 0 1-2.2-2.2v-2.6a2.2 2.2 0 0 1 2.2-2.2Zm11 0h2.6a2.2 2.2 0 0 1 2.2 2.2v2.6a2.2 2.2 0 0 1-2.2 2.2h-2.6a2.2 2.2 0 0 1-2.2-2.2v-2.6a2.2 2.2 0 0 1 2.2-2.2ZM17.5 2.3c.5 1.89 2.31 3.7 4.2 4.2-1.89.5-3.7 2.31-4.2 4.2-.5-1.89-2.31-3.7-4.2-4.2 1.89-.5 3.7-2.31 4.2-4.2Z',
  pointer: 'M9 9l5.5 12 1.8-5.2L21.5 14 9 9ZM12 3v3M5.2 5.2l2.1 2.1M3 12h3M18.8 5.2l-2.1 2.1',
  chat: 'M5 4h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-5 3V6a2 2 0 0 1 1-2Z',
  // Projects: a folder, one place for one piece of work.
  project: 'M3.5 7a2 2 0 0 1 2-2h3.6a2 2 0 0 1 1.5.7L12 7.5h6.5a2 2 0 0 1 2 2V17a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V7Z',
  search: 'm16 16 5 5M18 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z',
  command: 'M8 8H5a3 3 0 1 1 3-3v14a3 3 0 1 1-3-3h14a3 3 0 1 1-3 3V5a3 3 0 1 1 3 3H8Z',
  plus: 'M12 4v16M4 12h16',
  file: 'M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9Zm0 0v6h6M8 13h8M8 17h6',
  // The Library: books on a shelf, so it never looks like a project's folder.
  files: 'M5 4.5h3v15H5v-15Zm5.5 0h3v15h-3v-15Zm4.8 1.3 2.9-.8 3.6 13.7-2.9.8-3.6-13.7Z',
  skills: 'm12 3 8 5-8 5-8-5 8-5Zm-8 9 8 5 8-5M4 16l8 5 8-5',
  knowledge: 'M12 5c-3-2-6-2-9-1v15c3-1 6-1 9 1m0-15c3-2 6-2 9-1v15c-3-1-6-1-9 1V5Z',
  connections: 'M8 3v5m8-5v5M5 8h14v3a7 7 0 0 1-7 7m0 0v4m0-4a7 7 0 0 1-7-7',
  settings: 'M4 7h16M4 17h16M8 4v6m8 4v6',
  person: 'M16 7a4 4 0 1 0-8 0 4 4 0 0 0 8 0ZM4 21v-3a8 8 0 0 1 16 0v3',
  company: 'M5 21V3h14v18M2 21h20M9 7h1m4 0h1m-6 4h1m4 0h1m-6 4h1m4 0h1m-3 6v-3',
  card: 'M3 5h18v14H3V5Zm0 5h18M6 15h4',
  arrow: 'M4 12h16m-6-6 6 6-6 6',
  down: 'm6 9 6 6 6-6',
  chevron: 'm9 5 7 7-7 7',
  close: 'm6 6 12 12M6 18 18 6',
  expand: 'M14 3h7v7M21 3l-7 7M10 21H3v-7m0 7 7-7',
  menu: 'M4 6h16M4 12h16M4 18h16',
  more: 'M6 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z',
  check: 'm5 12 4 4L19 6',
  minus: 'M5 12h14',
  store:
    'M4 9.5 5.5 4h13L20 9.5M4 9.5a2.67 2.67 0 0 0 5.33 0 2.67 2.67 0 0 0 5.34 0 2.67 2.67 0 0 0 5.33 0M5.5 12v8h13v-8M10 20v-4.5h4V20',
  clock: 'M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0Zm-9-5v5l3 2',
  download: 'M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5',
  upload: 'M12 16V4m-5 5 5-5 5 5M4 16v5h16v-5',
  play: 'm7 4 13 8-13 8V4Z',
  table: 'M3 4h18v16H3V4Zm0 5h18M9 9v11m6-11v11',
  results: 'M5 20V11m7 9V4m7 16v-7M2 21h20',
  meetings:
    'M12 3a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3Zm-7 8a7 7 0 0 0 14 0m-7 7v3m-4 0h8',
  source: 'M10 14a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-2 2m2 4a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l2-2',
  globe: 'M21 12a9 9 0 1 0-18 0 9 9 0 0 0 18 0ZM3 12h18M12 3c5 5 5 13 0 18-5-5-5-13 0-18Z',
  logout: 'M9 4H4v16h5m4-4 4-4-4-4m-5 4h13',
  sun: 'M12 3v2m0 14v2M3 12h2m14 0h2M5.6 5.6l1.4 1.4m10 10 1.4 1.4m0-12.8-1.4 1.4m-10 10-1.4 1.4M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z',
  moon: 'M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5 8.5 8.5 0 1 0 20.5 14.5Z',
  inbox: 'M4 13h4l2 3h4l2-3h4M4 13l2.5-8h11l2.5 8v6H4v-6Z',
  history: 'M3 12a9 9 0 1 0 2.6-6.4L3 8m0-5v5h5m4-1v5l3 2',
  edit: 'M4 20h4L19 9l-4-4L4 16v4Zm9-13 4 4',
  home: 'M4 11 12 4l8 7v9H4v-9Z',
  // Agents: a worker with a spark, set apart from people (person, users).
  agents:
    'M10 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 10v-1a7 7 0 0 1 9.5-6.5M18 13c.4 1.6 1.4 2.6 3 3-1.6.4-2.6 1.4-3 3-.4-1.6-1.4-2.6-3-3 1.6-.4 2.6-1.4 3-3Z',
  key: 'M14.5 4a5.5 5.5 0 1 1-5 7.8L4 17.3V20h3v-2h2v-2h2l1.2-1.2A5.5 5.5 0 0 1 14.5 4Zm1.5 4h.01',
  copy: 'M9 9h11v11H9V9Zm-4 6H4V4h11v1',
  lock: 'M6 11h12v10H6V11Zm2 0V8a4 4 0 0 1 8 0v3',
  users:
    'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 10v-1a6 6 0 0 1 12 0v1m2-18a4 4 0 0 1 0 8m6 10v-1a6 6 0 0 0-4-5.6',
  eye: 'M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7S2 12 2 12Zm13 0a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z',
  database:
    'M5 6c0-1.7 3.1-3 7-3s7 1.3 7 3-3.1 3-7 3-7-1.3-7-3Zm0 0v12c0 1.7 3.1 3 7 3s7-1.3 7-3V6M5 12c0 1.7 3.1 3 7 3s7-1.3 7-3',
  shield: 'M12 3 4 6v6c0 4.5 3.4 8 8 9 4.6-1 8-4.5 8-9V6l-8-3Zm-3.5 9 2.5 2.5 4.5-5',
  alert: 'M12 3 2.5 20h19L12 3Zm0 6.5v4.5m0 3h.01',
  fork: 'M7 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-5 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM7 7v1a4 4 0 0 0 4 4h2a4 4 0 0 0 4-4V7m-5 5v5',
  // Artifact kinds (ARTIFACTS-DESIGN §8.1), drawn like the rest of this set.
  dashboard: 'M3 3h7v9H3V3Zm11 0h7v5h-7V3Zm0 9h7v9h-7v-9ZM3 16h7v5H3v-5Z',
  slides: 'M2 3h20M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3m4 18 5-5 5 5',
  document:
    'M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7l-5-5Zm-1 0v4a2 2 0 0 0 2 2h4M10 9H8m8 4H8m8 4H8',
  report:
    'M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7l-5-5Zm-1 0v4a2 2 0 0 0 2 2h4M8 18v-1m4 1v-3m4 3v-5',
} as const;
export type WorkspaceIconName = keyof typeof paths;
export function WorkspaceIcon({
  name,
  size = 18,
  className,
  style,
  ...props
}: {
  name: WorkspaceIconName;
  size?: number;
  className?: string;
  style?: CSSProperties;
} & DomMetadata) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.65"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      style={style}
      {...splitDomMetadata(props).metadata}
    >
      <path d={paths[name]} />
    </svg>
  );
}
